import { render, staticRenderFns } from "./TicketBanner.vue?vue&type=template&id=67c9d40d&scoped=true"
import script from "./TicketBanner.vue?vue&type=script&lang=js"
export * from "./TicketBanner.vue?vue&type=script&lang=js"
import style0 from "./TicketBanner.vue?vue&type=style&index=0&id=67c9d40d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9d40d",
  null
  
)

export default component.exports